import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowExpandHor: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowExpandHor"><Path fillRule="evenodd" clipRule="evenodd" d="M7.41436 7.99991L4.41437 10.9999H19.5859L16.5859 7.99991L18.0001 6.58569L23.4144 11.9999L18.0002 17.4141L16.5859 15.9999L19.5859 12.9999H4.41436L7.41436 15.9999L6.00015 17.4141L0.585938 11.9999L6.00015 6.58569L7.41436 7.99991Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowExpandHor;
